import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "refund-reason" }
const _hoisted_4 = { class: "transaction-id" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "time-value" }
const _hoisted_8 = { class: "time-value" }
const _hoisted_9 = { key: 2 }

import { computed, onMounted, reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import request from '@/utils/request'

type RefundRecord = {
  id: number
  user_id: number
  package_type: string
  package_amount: number
  consumed_points: number
  refund_reason: string
  alipay_account: string
  refund_amount: number
  transaction_id: string
  platform: string
  registrant_id: number
  registrant_user_name?: string | null
  operator_id: number
  operator_user_name?: string | null
  status: string
  order_time: string
  created_at: string
}

type RefundOrder = {
  order_id: string
  vip_meal_name: string
  package_amount: number
  transaction_id: string
  platform: string
  order_time: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'refund',
  setup(__props) {

const loading = ref(false)
const creating = ref(false)
const orderLoading = ref(false)
const createOpen = ref(false)
const statusModalOpen = ref(false)
const updating = ref(false)
const records = ref<RefundRecord[]>([])
const hasSearched = ref(false)
const order = ref<RefundOrder | null>(null)
const store = useStore()
const canOperate = computed(() => Number(store.state.user?.user_role) === 4 || [862515, 548814, 37].includes(Number(store.state.user?.user_id)))
const filters = reactive({ user_id: '', status: 'REGISTERED' as string | undefined, createdRange: null as string[] | null })
const createForm = reactive({ user_id: '', platform: '', consumed_points: 0, refund_reason: '', alipay_account: '' })
const statusForm = reactive({ record: null as RefundRecord | null, status: '' as 'REFUNDED' | 'REJECTED' | '', remark: '' })
const pagination = reactive({ total: 0, current: 1, pageSize: 20, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] })

const statusOptions = [
  { label: '已登记', value: 'REGISTERED' },
  { label: '已退款', value: 'REFUNDED' },
  { label: '不可退', value: 'REJECTED' },
]

const platformOptions = [
  { label: 'iOS', value: 'IOS' },
  { label: 'Android', value: 'ANDROID' },
]

const columns = [
  { title: '用户 ID', dataIndex: 'user_id', width: 85, customCell: () => ({ class: 'single-line-cell' }) },
  { title: '套餐', dataIndex: 'package_type', width: 80 },
  { title: '套餐金额', key: 'package_amount', slots: { customRender: 'package_amount' }, width: 90 },
  { title: '消耗积分', dataIndex: 'consumed_points', width: 105, customCell: () => ({ class: 'single-line-cell' }) },
  { title: '退款金额', key: 'refund_amount', slots: { customRender: 'refund_amount' }, width: 90 },
  { title: '退款原因', key: 'refund_reason', slots: { customRender: 'refund_reason' }, width: 140 },
  { title: '支付宝账号', dataIndex: 'alipay_account', ellipsis: true, width: 130 },
  { title: '交易 ID', key: 'transaction_id', slots: { customRender: 'transaction_id' }, width: 160 },
  { title: '平台', dataIndex: 'platform', width: 90 },
  { title: '登记人', key: 'registrant_id', slots: { customRender: 'registrant_id' }, width: 100 },
  { title: '操作人', key: 'operator_id', slots: { customRender: 'operator_id' }, width: 100 },
  { title: '状态', key: 'status', slots: { customRender: 'status' }, width: 100 },
  { title: '登记时间', key: 'created_at', slots: { customRender: 'created_at' }, width: 110 },
  { title: '订单时间', key: 'order_time', slots: { customRender: 'order_time' }, width: 110 },
  { title: '操作', key: 'actions', slots: { customRender: 'actions' }, fixed: 'right', width: 150 },
]

const centsToYuan = (cents: number) => `¥${((cents || 0) / 100).toFixed(2)}`
const formatDate = (value: string) => value || '-'
const datePart = (value: string) => formatDate(value).replace('T', ' ').split(' ')[0]
const timePart = (value: string) => formatDate(value).replace('T', ' ').split(' ')[1] || ''
const statusLabel = (status: string) => ({ REGISTERED: '已登记', REFUNDED: '已退款', REJECTED: '不可退' }[status] || status)
const statusColor = (status: string) => ({ REGISTERED: 'processing', REFUNDED: 'success', REJECTED: 'default' }[status] || 'default')
const statusModalTitle = computed(() => statusForm.status === 'REFUNDED' ? '标记已退款' : '标记不可退')

async function loadRecords(page = pagination.current, pageSize = pagination.pageSize) {
  loading.value = true
  try {
    const response: any = await request.get('/api/user/refunds/search', {
      user_id: filters.user_id,
      status: filters.status,
      created_start: filters.createdRange?.[0],
      created_end: filters.createdRange?.[1],
      offset: (page - 1) * pageSize,
      limit: pageSize,
    })
    const data = response?.data || {}
    records.value = data.list || []
    pagination.total = data.pagination?.total || 0
    pagination.current = page
    pagination.pageSize = pageSize
  } catch (_error) {
    records.value = []
    pagination.total = 0
    pagination.current = page
    pagination.pageSize = pageSize
  } finally {
    loading.value = false
  }
}

function search() {
  hasSearched.value = true
  loadRecords(1, pagination.pageSize)
}
onMounted(() => search())
function handleTableChange(page: { current: number; pageSize: number }) { loadRecords(page.current, page.pageSize) }
function openCreate() { createOpen.value = true }
function resetCreateForm() {
  order.value = null
  createForm.user_id = ''
  createForm.platform = ''
  createForm.consumed_points = 0
  createForm.refund_reason = ''
  createForm.alipay_account = ''
}

async function loadOrder() {
  if (!createForm.user_id) return message.warning('请输入用户 ID')
  orderLoading.value = true
  order.value = null
  try {
    const orderResponse: any = await request.get('/api/user/refunds/orders', { user_id: createForm.user_id })
    order.value = orderResponse.data
    createForm.platform = String(order.value?.platform || '').toUpperCase()
    if (!order.value?.order_time) {
      order.value = null
      orderLoading.value = false
      return message.error('未查询到可登记退款的订单')
    }
  } catch (_error) {
    order.value = null
    createForm.platform = ''
    createForm.consumed_points = 0
    orderLoading.value = false
    message.error('订单查询失败，请重试')
    return
  }

  try {
    const pointsResponse: any = await request.get('/api/user/refunds/points', { user_id: createForm.user_id, order_time: order.value.order_time })
    createForm.consumed_points = pointsResponse.data?.member_points || 0
  } catch (_error) {
    createForm.consumed_points = 0
    message.warning('查询消耗积分失败，请手工填写')
  } finally {
    orderLoading.value = false
  }
}

async function createRefund() {
  if (!order.value || !createForm.refund_reason.trim()) return message.warning('请先查询订单并填写退款原因')
  if (!createForm.platform) return message.warning('请选择平台')
  if (!createForm.alipay_account.trim()) return message.warning('请输入支付宝账号')
  creating.value = true
  try {
    await request.post('/api/user/refunds/create', {
      user_id: Number(createForm.user_id),
      order_id: order.value.order_id,
      consumed_points: createForm.consumed_points,
      refund_reason: createForm.refund_reason,
      alipay_account: createForm.alipay_account,
      platform: createForm.platform,
    })
    createOpen.value = false
    resetCreateForm()
    hasSearched.value = true
    loadRecords(1, pagination.pageSize)
  } catch (_error) {
    message.error('退款登记失败，请重试')
  } finally {
    creating.value = false
  }
}

function openStatusModal(record: RefundRecord, status: 'REFUNDED' | 'REJECTED') {
  if (!canOperate.value) return notifyNoPermission()
  statusForm.record = record
  statusForm.status = status
  statusForm.remark = ''
  statusModalOpen.value = true
}

function resetStatusForm() {
  statusForm.record = null
  statusForm.status = ''
  statusForm.remark = ''
}

async function submitStatusUpdate() {
  if (!statusForm.record || !statusForm.status || !statusForm.remark.trim()) return message.warning('请填写操作原因')
  updating.value = true
  try {
    await request.put(`/api/user/refunds/${statusForm.record.id}/update`, { status: statusForm.status, remark: statusForm.remark })
    statusModalOpen.value = false
    resetStatusForm()
    loadRecords()
  } catch (_error) {
    message.error('更新退款状态失败，请重试')
  } finally {
    updating.value = false
  }
}

function notifyNoPermission() { message.warning('无操作权限') }


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, { title: "退款工具" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "inline",
          model: filters,
          class: "search-form",
          onFinish: search
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "用户 ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: filters.user_id,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((filters.user_id) = $event)),
                  "allow-clear": "",
                  placeholder: "请输入用户 ID"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "退款状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: filters.status,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((filters.status) = $event)),
                  "allow-clear": "",
                  placeholder: "全部",
                  options: statusOptions,
                  class: "status-select"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "登记时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: filters.createdRange,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((filters.createdRange) = $event)),
                  "show-time": "",
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  format: "YYYY-MM-DD HH:mm"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit"
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("查询", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      ghost: "",
                      onClick: openCreate
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("登记退款", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        (hasSearched.value)
          ? (_openBlock(), _createBlock(_component_a_table, {
              key: 0,
              "row-key": "id",
              columns: columns,
              "data-source": records.value,
              loading: loading.value,
              pagination: pagination,
              onChange: handleTableChange
            }, {
              headerCell: _withCtx(({ column }) => [
                (column.key === 'refund_amount')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                      _cache[13] || (_cache[13] = _createTextVNode(" 退款金额 ", -1)),
                      _createVNode(_component_a_tooltip, { title: "退款金额（分）= 向下取整（套餐金额 ×（1 - 平台手续费率）- 消耗积分 × 3.8）；iOS 手续费率为 30%，Android 手续费率为 0.6%。" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(QuestionCircleOutlined), { class: "formula-tip" })
                        ]),
                        _: 1
                      })
                    ]))
                  : (column.key === 'actions')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _cache[14] || (_cache[14] = _createTextVNode(" 操作 ", -1)),
                        _createVNode(_component_a_tooltip, { title: "仅更改退款登记状态，不修改订单状态。" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(QuestionCircleOutlined), { class: "formula-tip" })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(column.title), 1)
                      ], 64))
              ]),
              package_amount: _withCtx(({ record }) => [
                _createTextVNode(_toDisplayString(centsToYuan(record.package_amount)), 1)
              ]),
              refund_amount: _withCtx(({ record }) => [
                _createTextVNode(_toDisplayString(centsToYuan(record.refund_amount)), 1)
              ]),
              refund_reason: _withCtx(({ record }) => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(record.refund_reason), 1)
              ]),
              transaction_id: _withCtx(({ record }) => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(record.transaction_id), 1)
              ]),
              registrant_id: _withCtx(({ record }) => [
                _createTextVNode(_toDisplayString(record.registrant_id) + " ", 1),
                (record.registrant_user_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "(" + _toDisplayString(record.registrant_user_name) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              operator_id: _withCtx(({ record }) => [
                _createTextVNode(_toDisplayString(record.operator_id || '') + " ", 1),
                (record.operator_user_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "(" + _toDisplayString(record.operator_user_name) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              status: _withCtx(({ record }) => [
                _createVNode(_component_a_tag, {
                  color: statusColor(record.status)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(statusLabel(record.status)), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              created_at: _withCtx(({ record }) => [
                _createElementVNode("span", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(datePart(record.created_at)), 1),
                  _createElementVNode("span", null, _toDisplayString(timePart(record.created_at)), 1)
                ])
              ]),
              order_time: _withCtx(({ record }) => [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(datePart(record.order_time)), 1),
                  _createElementVNode("span", null, _toDisplayString(timePart(record.order_time)), 1)
                ])
              ]),
              actions: _withCtx(({ record }) => [
                (record.status === 'REGISTERED' && canOperate.value)
                  ? (_openBlock(), _createBlock(_component_a_space, {
                      key: 0,
                      direction: "vertical",
                      size: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (openStatusModal(record, 'REFUNDED'))
                        }, {
                          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createTextVNode("标记已退款", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_a_button, {
                          danger: "",
                          size: "small",
                          onClick: ($event: any) => (openStatusModal(record, 'REJECTED'))
                        }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("不可退", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : (record.status === 'REGISTERED')
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "link",
                        danger: "",
                        size: "small",
                        onClick: notifyNoPermission
                      }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("无操作权限", -1)
                        ]))]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
              ]),
              _: 1
            }, 8, ["data-source", "loading", "pagination"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      open: statusModalOpen.value,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((statusModalOpen).value = $event)),
      title: statusModalTitle.value,
      "confirm-loading": updating.value,
      onOk: submitStatusUpdate,
      onCancel: resetStatusForm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { "label-col": { span: 6 } }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: statusForm.status === 'REFUNDED' ? '允许退款原因' : '不可退款原因',
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: statusForm.remark,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((statusForm.remark) = $event)),
                  rows: 3,
                  placeholder: "请输入操作原因"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "title", "confirm-loading"]),
    _createVNode(_component_a_modal, {
      open: createOpen.value,
      "onUpdate:open": _cache[10] || (_cache[10] = ($event: any) => ((createOpen).value = $event)),
      title: "登记退款",
      "confirm-loading": creating.value,
      onOk: createRefund,
      onCancel: resetCreateForm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: createForm,
          "label-col": { span: 6 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "用户 ID",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: createForm.user_id,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((createForm.user_id) = $event)),
                  placeholder: "输入后查询最近订单",
                  "enter-button": "查询订单",
                  loading: orderLoading.value,
                  onSearch: loadOrder
                }, null, 8, ["value", "loading"])
              ]),
              _: 1
            }),
            (order.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_a_descriptions, {
                    size: "small",
                    column: 2,
                    bordered: "",
                    class: "order-summary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_descriptions_item, { label: "套餐" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.value.vip_meal_name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "套餐金额" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(centsToYuan(order.value.package_amount)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "平台" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.value.platform), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "订单时间" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.value.order_time), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, {
                        label: "交易 ID",
                        span: 2
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.value.transaction_id), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "平台",
                    required: "",
                    class: "form-item-top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: createForm.platform,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((createForm.platform) = $event)),
                        options: platformOptions,
                        disabled: Boolean(order.value.platform),
                        placeholder: "请选择平台",
                        class: "full-width"
                      }, null, 8, ["value", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "消耗会员积分",
                    required: "",
                    class: "form-item-top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_number, {
                        value: createForm.consumed_points,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((createForm.consumed_points) = $event)),
                        min: 0,
                        precision: 0,
                        class: "full-width"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "退款原因",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: createForm.refund_reason,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((createForm.refund_reason) = $event)),
                        rows: 3,
                        placeholder: "请输入退款原因"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "支付宝账号",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: createForm.alipay_account,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((createForm.alipay_account) = $event)),
                        placeholder: "可退款时必填"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createBlock(_component_a_empty, {
                  key: 1,
                  description: "请先通过用户 ID 查询订单"
                }))
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open", "confirm-loading"])
  ], 64))
}
}

})